import PRODUCT_ID_MAPPER from '../containers/analysis/constants';
import { ScalpType } from '../containers/analysis/constants';
import PRODUCTS from '../containers/analysis/product/constants';
import GOOD_BAD_CATEGORY from '../containers/analysis/goodBadCategory/constants';
import { Category } from '../containers/analysis/constants';

// 문진 결과로 제품 레시피 추천
export const makeKit = ({
  scalp_type,
  scalp_type_2,
  hair_preference,
  treatment_product,
  products,
  quizzes,
  product_variation,
  // subscription_discount_percent,
}) => {
  let kit = [];

  // 데일리 샴푸
  let productBaseInfo = products.find(
    (product) => product.id === PRODUCT_ID_MAPPER[scalp_type],
  );

  let product_variation_id =
    product_variation === 'main' &&
    productBaseInfo.productItemVariations.find(
      (item) => item.is_sell === 'YES' && item.variation_type === 'NORMAL',
    ).id;

  // productBaseInfo.productItemVariations.slice(-1)[0].id;

  let productInfo = productBaseInfo.productItemVariations.find(
    (v) => v.id === product_variation_id,
  );
  kit.push({
    volume: parseInt(productInfo.container_volume),
    price: productInfo.price,
    name_en: productBaseInfo.name,
    name_kr: productBaseInfo.abstract,
    kit_label_en: 'Daily Shampoo',
    kit_label_kr: '데일리 샴푸',
    ...{ ...PRODUCTS[PRODUCT_ID_MAPPER[scalp_type]] },
    product_variation_id,
    is_daily_shampoo: true,
  });

  // 위켄드 샴푸
  if (scalp_type_2) {
    if (
      PRODUCT_ID_MAPPER[scalp_type_2] === kit[0].product_id &&
      scalp_type_2 !== ScalpType.GENERAL
    ) {
      // * 두피타입이 건성&민감성인 경우 Give Me Water 두개 나오는 것 방지
      // * 이 경우 Give Me Water + General로 추천함
      productBaseInfo = products.find(
        (product) => product.id === PRODUCT_ID_MAPPER[ScalpType.GENERAL],
      );
      product_variation_id =
        product_variation === 'main'
          ? productBaseInfo.productItemVariations.find(
              (item) =>
                item.is_sell === 'YES' && item.variation_type === 'NORMAL',
            ).id
          : PRODUCTS[PRODUCT_ID_MAPPER[ScalpType.GENERAL]].product_variations[
              product_variation
            ];
      productInfo = productBaseInfo.productItemVariations.find(
        (v) => v.id === product_variation_id,
      );

      kit.push({
        volume: parseInt(productInfo.container_volume),
        price: productInfo.price,
        name_en: productBaseInfo.name,
        name_kr: productBaseInfo.abstract,
        kit_label_en: 'Weekend Shampoo',
        kit_label_kr: '위켄드 샴푸',
        // low_price:
        //     (productInfo.price * (100 - subscription_discount_percent)) / 100,
        ...{ ...PRODUCTS[PRODUCT_ID_MAPPER[ScalpType.GENERAL]] },
        product_variation_id,
        is_daily_shampoo: false,
      });
    } else {
      productBaseInfo = products.find(
        (product) => product.id === PRODUCT_ID_MAPPER[scalp_type_2],
      );
      product_variation_id =
        product_variation === 'main'
          ? productBaseInfo.productItemVariations.find(
              (item) =>
                item.is_sell === 'YES' && item.variation_type === 'NORMAL',
            ).id
          : PRODUCTS[PRODUCT_ID_MAPPER[scalp_type_2]].product_variations[
              product_variation
            ];
      productInfo = productBaseInfo.productItemVariations.find(
        (v) => v.id === product_variation_id,
      );
      kit.push({
        volume: parseInt(productInfo.container_volume),
        price: productInfo.price,
        name_en: productBaseInfo.name,
        name_kr: productBaseInfo.abstract,
        kit_label_en: 'Weekend Shampoo',
        kit_label_kr: '위켄드 샴푸',
        // low_price:
        //     (productInfo.price * (100 - subscription_discount_percent)) / 100,
        ...{ ...PRODUCTS[PRODUCT_ID_MAPPER[scalp_type_2]] },
        product_variation_id,
      });
    }
  }

  // 트리트먼트
  if (hair_preference === 'SOFT' || treatment_product === 'YES') {
    productBaseInfo = products.find(
      (product) => product.id === PRODUCT_ID_MAPPER.TREATMENT,
    );
    product_variation_id =
      product_variation === 'main'
        ? productBaseInfo.productItemVariations.find(
            (item) =>
              item.is_sell === 'YES' && item.variation_type === 'NORMAL',
          ).id
        : PRODUCTS[PRODUCT_ID_MAPPER.TREATMENT].product_variations[
            product_variation
          ];
    productInfo = productBaseInfo.productItemVariations.find(
      (v) => v.id === product_variation_id,
    );
    kit.push({
      volume: parseInt(productInfo.container_volume),
      price: productInfo.price,
      name_en: productBaseInfo.name,
      name_kr: productBaseInfo.abstract,
      kit_label_en: 'Treatment',
      kit_label_kr: '트리트먼트',
      ...{ ...PRODUCTS[PRODUCT_ID_MAPPER.TREATMENT] },
      product_variation_id,
    });
  }

  if (product_variation === 'sampler') return kit;

  // 앰플 or 에센스 (서로 배타적)
  const ampleEssence = [
    { id: 14, key: 'inflammation_2', product: 'AMPLE' },
    { id: 13, key: 'inflammation', product: 'AMPLE' }, //염증
    { id: 11, key: 'itching', product: 'ESSENCE' }, //가려움
    { id: 6, key: 'pimple', product: 'AMPLE' }, // 뾰루지
    { id: 8, key: 'dryness', product: 'ESSENCE' }, //각질
    { id: 12, key: 'sensitivity_2', product: 'AMPLE' }, //민감도
    { id: 10, key: 'sensitivity', product: 'AMPLE' },
    { id: 9, key: 'dry_dandruff', product: 'ESSENCE' }, //비듬
    { id: 15, key: 'scalp_fever', product: 'ESSENCE' }, //두피열
    { id: 16, key: 'hair_loss_type', product: 'AMPLE' }, //탈모 U OR M OR ETC...
  ];
  ampleEssence.some((el) => {
    productBaseInfo = products.find(
      (product) => product.id === PRODUCT_ID_MAPPER[el.product],
    );
    product_variation_id = productBaseInfo.productItemVariations.find(
      (item) => item.is_sell === 'YES' && item.variation_type === 'NORMAL',
    ).id;
    // product_variation_id =
    //   productBaseInfo.productItemVariations.slice(-1)[0].id;

    productInfo = productBaseInfo.productItemVariations.find(
      (v) => v.id === product_variation_id,
    );
    if (
      (el.id === 16 && quizzes[el.id][el.key] !== 'NONE') ||
      quizzes[el.id][el.key] > 0
    ) {
      kit.push({
        volume: parseInt(productInfo.container_volume),
        price: productInfo.price,
        name_en: productBaseInfo.name,
        name_kr: productBaseInfo.abstract,
        kit_label_en: el.product === 'AMPLE' ? 'Ample' : 'Essence',
        kit_label_kr: el.product === 'AMPLE' ? '두피 앰플' : '두피 에센스',
        // low_price:
        //     (productInfo.price * (100 - subscription_discount_percent)) / 100,

        ...{ ...PRODUCTS[PRODUCT_ID_MAPPER[el.product]] },
        product_variation_id,
      });
      return true;
    }
    return false;
  });

  return kit;
};

// 두피고민 우선순위 3가지를 추출하고 이에 따른 유익한/피해야 할 성분 카테고리 알려주기
export const stateGoodBadCategory = (scalpType, analysis, isBeconShampoo) => {
  // cares ---> issue
  let issues = [];
  if (!analysis) return issues;

  const handleScalpIssue = (key) => {
    if (key === 'ITCHING') {
      // analysis.scalp_type
      issues.push({
        key: key,
        good: GOOD_BAD_CATEGORY.scalpIssue[key][scalpType].good.slice(0, 5),
        bad: GOOD_BAD_CATEGORY.scalpIssue[key][scalpType].bad.slice(0, 5),
        type: 'scalpIssue',
      });
    } else {
      issues.push({
        key: key,
        good: GOOD_BAD_CATEGORY.scalpIssue[key].good.slice(0, 5),
        bad: GOOD_BAD_CATEGORY.scalpIssue[key].bad.slice(0, 5),
        type: 'scalpIssue',
      });
    }
  };

  // 1. 두피고민 1~3
  if (isBeconShampoo) {
    analysis.scalp_issue?.issue_1 &&
      handleScalpIssue(analysis.scalp_issue.issue_1);
    analysis.scalp_issue?.issue_2 &&
      handleScalpIssue(analysis.scalp_issue.issue_2);
    if (analysis.scalp_issue?.issue_3) {
      handleScalpIssue(analysis.scalp_issue.issue_3);
      if (issues.length === 3) return issues;
    }
  } else {
    //B2B
    analysis?.primary && handleScalpIssue(analysis.primary);
    analysis?.secondary && handleScalpIssue(analysis.secondary);
    if (analysis?.tertiary) {
      handleScalpIssue(analysis.tertiary);
      if (issues.length === 3) return issues;
    }
  }

  // 2. 두피타입 1~2
  if (analysis.scalp_type) {
    const key = analysis.scalp_type;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.scalpType[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.scalpType[key].bad.slice(0, 5),
      type: 'scalpType',
    });
    if (issues.length === 3) return issues;
  }
  if (analysis.scalp_type_2) {
    const key = analysis.scalp_type_2;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.scalpType[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.scalpType[key].bad.slice(0, 5),
      type: 'scalpType',
    });
    if (issues.length === 3) return issues;
  }

  // 3. 샴푸 선호도 1~2
  if (
    analysis.preference?.shampoo_1 &&
    GOOD_BAD_CATEGORY.preferenceShampoo.hasOwnProperty(
      analysis.preference.shampoo_1,
    )
  ) {
    const key = analysis.preference.shampoo_1;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.preferenceShampoo[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.preferenceShampoo[key].bad.slice(0, 5),
      type: 'preferenceShampoo',
    });
    if (issues.length === 3) return issues;
  }
  if (
    analysis.preference?.shampoo_2 &&
    GOOD_BAD_CATEGORY.preferenceShampoo.hasOwnProperty(
      analysis.preference.shampoo_2,
    )
  ) {
    const key = analysis.preference.shampoo_2;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.preferenceShampoo[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.preferenceShampoo[key].bad.slice(0, 5),
      type: 'preferenceShampoo',
    });
    if (issues.length === 3) return issues;
  }

  // 4. 머릿결 선호도 1
  if (analysis.preference?.hair_1) {
    const key = analysis.preference.hair_1;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.preferenceHair[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.preferenceHair[key].bad.slice(0, 5),
      type: 'preferenceHair',
    });
    if (issues.length === 3) return issues;
  }

  // 5. 생활습관
  if (
    analysis.lifestyle?.dyeing &&
    analysis.lifestyle.dyeing !== null &&
    analysis.lifestyle.dyeing !== 'NONE'
  ) {
    const key = 'dyeing';
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.lifestyle[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.lifestyle[key].bad.slice(0, 5),
      type: 'lifestyle',
    });
    if (issues.length === 3) return issues;
  }
  if (
    analysis.lifestyle?.perm &&
    analysis.lifestyle.perm !== null &&
    analysis.lifestyle.perm !== 'NONE'
  ) {
    const key = 'perm';
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.lifestyle[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.lifestyle[key].bad.slice(0, 5),
      type: 'lifestyle',
    });
    if (issues.length === 3) return issues;
  }

  // 6. 공통성분
  const key = 'common';
  issues.push({
    key: key,
    good: GOOD_BAD_CATEGORY.common[key].good.slice(0, 5),
    bad: GOOD_BAD_CATEGORY.common[key].bad.slice(0, 5),
    type: 'common',
  });

  return issues;
};

// 블렌디드 킷 이미지 렌더링시 필요한 배치 id(0~7) 반환
export const getBlendedKitArrangementCase = (kit) => {
  const shampooQty = kit.filter(
    (el) => el.category === Category.SHAMPOO,
  ).length; // 1/2
  const treatmentQty = kit.filter(
    (el) => el.category === Category.TREATMENT,
  ).length; // 0/1
  const otherQty = kit.filter(
    (el) => el.category === Category.AMPLE || el.category === Category.ESSENCE,
  ).length; // 0/1
  return '' + shampooQty + treatmentQty + otherQty;
};
